<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { useVModel } from '@vueuse/core'
import { ref, computed } from 'vue'
import { Button } from '@/components/ui/button'
import { EyeIcon, EyeOffIcon } from 'lucide-vue-next'

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
  class?: HTMLAttributes['class']
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const showPassword = ref(false)
const inputType = computed(() => {
  return showPassword.value ? 'text' : 'password'
})
</script>

<template>
  <div class="relative">
    <input
      v-model="modelValue"
      :type="inputType"
      :class="cn('flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', props.class)"
    >
    <button
      type="button"
      tabindex="-1"
      @click="showPassword = !showPassword"
      class="absolute inset-y-0 right-0 flex items-center pr-3 text-sm leading-5 text-gray-500 pl-3"
    >
      <EyeIcon v-if="!showPassword" class="h-4 w-4" />
      <EyeOffIcon v-else class="h-4 w-4" />
    </button>
  </div>

</template>
